import { render, staticRenderFns } from "./addSubAccount.vue?vue&type=template&id=2ad1bcb8&lang=pug&"
import script from "./addSubAccount.vue?vue&type=script&lang=js&"
export * from "./addSubAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports